// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.branch-details-container {
  padding: 1rem;
  background-color: #f4f6f8;
  color: #1f2937;
}
.branch-details-container .branch-main-det {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.branch-details-container .branch-main-det h3 {
  font-size: 1.3rem;
  color: #374151;
}
.branch-details-container .branch-main-det h3 span {
  color: var(--primary-color);
}
.branch-details-container h2 {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  color: #111827;
}
.branch-details-container .empty {
  color: #6b7280;
}
.branch-details-container .member-list {
  list-style: none;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}
.branch-details-container .branch-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.branch-details-container .members-grid {
  margin-top: 1rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}
.branch-details-container .member-card {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.branch-details-container .member-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}
.branch-details-container .member-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.branch-details-container .member-name {
  margin: 0;
  font-size: 1.1em;
  font-weight: 600;
}
.branch-details-container .members-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}
.branch-details-container .members-table th,
.branch-details-container .members-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}
.branch-details-container .members-table th {
  background-color: #f8f9fa;
  font-weight: 600;
}
.branch-details-container .members-table tr:hover {
  background-color: #f1f3f5;
  cursor: pointer;
}
.branch-details-container .role-badge {
  background: #007bff;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.8em;
  font-weight: 500;
}
.branch-details-container .member-card {
  cursor: pointer;
  background: #fff;
  border: 1px solid #ddd;
  padding: 1.25rem;
  border-radius: 10px;
}
.branch-details-container .member-card p {
  margin: 0.4rem 0;
  font-size: 0.95rem;
}
.branch-details-container .member-card p strong {
  color: #000;
  margin-right: 0.25rem;
}
.branch-details-container .member-card .role-badge {
  display: inline-block;
  background-color: #d2f8d2;
  color: #267326;
  border-radius: 5px;
  padding: 0.2rem 0.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  margin-left: 0.5rem;
  text-transform: capitalize;
}
.branch-details-container .loading-msg {
  font-size: 1.1rem;
  text-align: center;
  margin-top: 3rem;
  color: #6b7280;
}

@media (max-width: 768px) {
  .branch-details-container {
    padding: 1.5rem;
  }
  .branch-details-container h2 {
    font-size: 1.75rem;
  }
  .branch-details-container h3 {
    font-size: 1.15rem;
  }
  .branch-details-container .member-card {
    padding: 1rem;
  }
  .branch-details-container .member-card p {
    font-size: 0.9rem;
  }
}
@media (max-width: 480px) {
  .branch-details-container {
    padding: 1rem;
  }
  .branch-details-container h2 {
    font-size: 1.5rem;
  }
  .branch-details-container h3 {
    font-size: 1rem;
  }
  .branch-details-container .member-card {
    padding: 0.85rem;
  }
  .branch-details-container .member-card p {
    font-size: 0.875rem;
  }
  .branch-details-container .member-card .role-badge {
    font-size: 0.7rem;
  }
}
@media (max-width: 360px) {
  .branch-details-container {
    padding: 0.75rem;
  }
  .branch-details-container h2 {
    font-size: 1.35rem;
  }
  .branch-details-container h3 {
    font-size: 0.95rem;
  }
  .branch-details-container .member-list {
    grid-template-columns: 1fr;
  }
  .branch-details-container .member-card {
    padding: 0.75rem;
  }
  .branch-details-container .member-card p {
    font-size: 0.82rem;
  }
  .branch-details-container .member-card .role-badge {
    font-size: 0.68rem;
    padding: 0.15rem 0.4rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/BranchDetails/BranchDetails.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,yBAAA;EACA,cAAA;AACF;AAEE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;AAAJ;AAII;EACE,iBAAA;EACA,cAAA;AAFN;AAIM;EACE,2BAAA;AAFR;AAyCI;EACE,iBAAA;EACA,qBAAA;EACA,cAAA;AAvCN;AA4CE;EACE,cAAA;AA1CJ;AA6CE;EACE,gBAAA;EACA,UAAA;EACA,aAAA;EACA,2DAAA;EACA,SAAA;EACA,gBAAA;AA3CJ;AA8CE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AA5CJ;AA+CE;EACE,gBAAA;EACA,aAAA;EACA,4DAAA;EACA,SAAA;AA7CJ;AAgDE;EACE,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;AA9CJ;AAiDE;EACE,wCAAA;EACA,2BAAA;AA/CJ;AAkDE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAhDJ;AAmDE;EACE,SAAA;EACA,gBAAA;EACA,gBAAA;AAjDJ;AAoDE;EACE,WAAA;EACA,yBAAA;EACA,gBAAA;AAlDJ;AAqDE;;EAEE,aAAA;EACA,gBAAA;EACA,6BAAA;AAnDJ;AAsDE;EACE,yBAAA;EACA,gBAAA;AApDJ;AAuDE;EACE,yBAAA;EACA,eAAA;AArDJ;AAwDE;EACE,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAtDJ;AAyDE;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;AAvDJ;AAgEI;EACE,gBAAA;EACA,kBAAA;AA9DN;AAgEM;EACE,WAAA;EACA,qBAAA;AA9DR;AAkEI;EACE,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;AAhEN;AAoEE;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAlEJ;;AAsEA;EACE;IACE,eAAA;EAnEF;EAqEE;IACE,kBAAA;EAnEJ;EAsEE;IACE,kBAAA;EApEJ;EAuEE;IACE,aAAA;EArEJ;EAuEI;IACE,iBAAA;EArEN;AACF;AA0EA;EACE;IACE,aAAA;EAxEF;EA0EE;IACE,iBAAA;EAxEJ;EA2EE;IACE,eAAA;EAzEJ;EA4EE;IACE,gBAAA;EA1EJ;EA4EI;IACE,mBAAA;EA1EN;EA6EI;IACE,iBAAA;EA3EN;AACF;AAgFA;EACE;IACE,gBAAA;EA9EF;EAgFE;IACE,kBAAA;EA9EJ;EAiFE;IACE,kBAAA;EA/EJ;EAkFE;IACE,0BAAA;EAhFJ;EAmFE;IACE,gBAAA;EAjFJ;EAmFI;IACE,kBAAA;EAjFN;EAoFI;IACE,kBAAA;IACA,uBAAA;EAlFN;AACF","sourcesContent":[".branch-details-container {\r\n  padding: 1rem;\r\n  background-color: #f4f6f8;\r\n  color: #1f2937;\r\n\r\n\r\n  .branch-main-det {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: flex-start;\r\n\r\n\r\n\r\n    h3 {\r\n      font-size: 1.3rem;\r\n      color: #374151;\r\n\r\n      span {\r\n        color: var(--primary-color);\r\n      }\r\n    }\r\n\r\n\r\n\r\n    // .view-toggle-wrapper {\r\n    //   display: flex;\r\n    //   gap: 5px;\r\n    // }\r\n\r\n    // .view-toggle-btn {\r\n    //   padding: 8px 12px;\r\n    //   border: 1px solid #ddd;\r\n    //   background: white;\r\n    //   cursor: pointer;\r\n    //   border-radius: 4px;\r\n    //   display: flex;\r\n    //   align-items: center;\r\n    //   justify-content: center;\r\n    // }\r\n\r\n    // .view-toggle-btn.active {\r\n    //   background: #007bff;\r\n    //   color: white;\r\n    //   border-color: #007bff;\r\n    // }\r\n\r\n    // .view-toggle-btn:hover {\r\n    //   background: #f8f9fa;\r\n    // }\r\n\r\n    // .view-toggle-btn.active:hover {\r\n    //   background: #0056b3;\r\n    // }\r\n\r\n\r\n  }\r\n  \r\n    h2 {\r\n      font-size: 1.5rem;\r\n      margin-bottom: 0.5rem;\r\n      color: #111827;\r\n\r\n\r\n    }\r\n\r\n  .empty {\r\n    color: #6b7280;\r\n  }\r\n\r\n  .member-list {\r\n    list-style: none;\r\n    padding: 0;\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\r\n    gap: 1rem;\r\n    margin-top: 1rem;\r\n  }\r\n\r\n  .branch-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .members-grid {\r\n    margin-top: 1rem;\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n    gap: 20px;\r\n  }\r\n\r\n  .member-card {\r\n    border: 1px solid #ddd;\r\n    border-radius: 8px;\r\n    padding: 16px;\r\n    cursor: pointer;\r\n    transition: all 0.2s ease;\r\n  }\r\n\r\n  .member-card:hover {\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n    transform: translateY(-2px);\r\n  }\r\n\r\n  .member-card-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 12px;\r\n  }\r\n\r\n  .member-name {\r\n    margin: 0;\r\n    font-size: 1.1em;\r\n    font-weight: 600;\r\n  }\r\n\r\n  .members-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    margin-top: 20px;\r\n  }\r\n\r\n  .members-table th,\r\n  .members-table td {\r\n    padding: 12px;\r\n    text-align: left;\r\n    border-bottom: 1px solid #ddd;\r\n  }\r\n\r\n  .members-table th {\r\n    background-color: #f8f9fa;\r\n    font-weight: 600;\r\n  }\r\n\r\n  .members-table tr:hover {\r\n    background-color: #f1f3f5;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .role-badge {\r\n    background: #007bff;\r\n    color: white;\r\n    padding: 4px 8px;\r\n    border-radius: 4px;\r\n    font-size: 0.8em;\r\n    font-weight: 500;\r\n  }\r\n\r\n  .member-card {\r\n    cursor: pointer;\r\n    background: #fff;\r\n    border: 1px solid #ddd;\r\n    padding: 1.25rem;\r\n    border-radius: 10px;\r\n    // box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04);\r\n    // transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n\r\n    // &:hover {\r\n    //   transform: translateY(-2px);\r\n    //   box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);\r\n    // }\r\n\r\n    p {\r\n      margin: 0.4rem 0;\r\n      font-size: 0.95rem;\r\n\r\n      strong {\r\n        color: #000;\r\n        margin-right: 0.25rem;\r\n      }\r\n    }\r\n\r\n    .role-badge {\r\n      display: inline-block;\r\n      background-color: #d2f8d2;\r\n      color: #267326;\r\n      border-radius: 5px;\r\n      padding: 0.2rem 0.5rem;\r\n      font-size: 0.75rem;\r\n      font-weight: 600;\r\n      margin-left: 0.5rem;\r\n      text-transform: capitalize;\r\n    }\r\n  }\r\n\r\n  .loading-msg {\r\n    font-size: 1.1rem;\r\n    text-align: center;\r\n    margin-top: 3rem;\r\n    color: #6b7280;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .branch-details-container {\r\n    padding: 1.5rem;\r\n\r\n    h2 {\r\n      font-size: 1.75rem;\r\n    }\r\n\r\n    h3 {\r\n      font-size: 1.15rem;\r\n    }\r\n\r\n    .member-card {\r\n      padding: 1rem;\r\n\r\n      p {\r\n        font-size: 0.9rem;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .branch-details-container {\r\n    padding: 1rem;\r\n\r\n    h2 {\r\n      font-size: 1.5rem;\r\n    }\r\n\r\n    h3 {\r\n      font-size: 1rem;\r\n    }\r\n\r\n    .member-card {\r\n      padding: 0.85rem;\r\n\r\n      p {\r\n        font-size: 0.875rem;\r\n      }\r\n\r\n      .role-badge {\r\n        font-size: 0.7rem;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 360px) {\r\n  .branch-details-container {\r\n    padding: 0.75rem;\r\n\r\n    h2 {\r\n      font-size: 1.35rem;\r\n    }\r\n\r\n    h3 {\r\n      font-size: 0.95rem;\r\n    }\r\n\r\n    .member-list {\r\n      grid-template-columns: 1fr; // fallback to single column\r\n    }\r\n\r\n    .member-card {\r\n      padding: 0.75rem;\r\n\r\n      p {\r\n        font-size: 0.82rem;\r\n      }\r\n\r\n      .role-badge {\r\n        font-size: 0.68rem;\r\n        padding: 0.15rem 0.4rem;\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
